import { FunctionComponent } from 'react'
import styled from 'styled-components'

import { ITypographyProps } from '../utils/types'

const CallOut2Text = styled.div<ITypographyProps>`
  font-weight: ${props => props.theme.fonts.weights.heavy};
  font-size: ${props => props.theme.fonts.sizes[22]}px;
  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.neutral900)};
  line-height: 30px;
  flex: none;
  flex-grow: 0;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    font-size: ${props => props.theme.fonts.sizes[28]}px;
    line-height: 38px;
  }

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: ${props => props.theme.fonts.sizes[32]}px;
    line-height: 44px;
  }
`

const CallOut2: FunctionComponent<ITypographyProps> = ({ children, ...props }) => (
  <CallOut2Text {...props}>{children}</CallOut2Text>
)
export default CallOut2
